import React from 'react';
import './ScheduleView.css';
import { TeamSportEvent } from '../../types/olympicsListableEvent';
import { TeamSportLayout } from './TeamSportLayout';

export const ResultsTeamEvent: React.FC<{
  participants: NonNullable<TeamSportEvent['participants']>;
}> = ({ participants }) => {
  const { teamOne, teamTwo } = participants;

  return (
    <TeamSportLayout
      participantOne={{ teamName: teamOne.teamName, countryId: teamOne.countryId }}
      participantTwo={{ teamName: teamTwo.teamName, countryId: teamTwo.countryId }}
    >
      <span className='team-score'>
        <span>{teamOne.finalResult}</span>–<span>{teamTwo.finalResult}</span>
      </span>
    </TeamSportLayout>
  );
};
